<template>
  <a
    title=""
    data-test="clear-bids"
    @click="showClearBidsDialog = true">
    Clear bids
  </a>
  <ConfirmationDialog
    v-model="showClearBidsDialog"
    :is-loading="clearMasterUserBidsMutation?.fetching?.value"
    @confirmation-selection="
      (confirm) => (confirm ? clearBids() : (showClearBidsDialog = false))
    ">
    <template #text-body>
      This action will clear all of the bids for the
      {{ currSchedDataIdsStore.currTeamId }} team for the
      {{ currSchedDataIdsStore.currSchedPeriodId }} schedule period.
    </template>
  </ConfirmationDialog>
</template>

<script setup lang="ts">
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
import { ClearMasterUserBidsDocument } from "owfsa-graphql";
import { useCurrSchedDataIdsStore } from "@/stores/currSchedDataIds.store";
import { useMutation } from "@urql/vue";
import { ref } from "vue";
import { toast } from "vue-sonner";

const clearMasterUserBidsMutation = useMutation(ClearMasterUserBidsDocument);
const currSchedDataIdsStore = useCurrSchedDataIdsStore();
const showClearBidsDialog = ref(false);

async function clearBids() {
  // TODO known issue that this won't refetch the bids after clearing them, needs refresh
  const result = await clearMasterUserBidsMutation.executeMutation({
    teamId: currSchedDataIdsStore.currTeamId,
    schedPeriodId: currSchedDataIdsStore.currSchedPeriodId,
  });

  if (!result.error && !!result.data) {
    toast.success("Bids have been cleared successfully");
    showClearBidsDialog.value = false;
  } else {
    const errorCode = result.error?.graphQLErrors?.[0].extensions.code;
    if (errorCode === "LIVE_SCHEDULE_PUBLISHED") {
      toast.error("A live schedule already exists. Please unpublish it before clearing bids.");
    } 
    toast.error("Error has occurred while clearing bids");
  }
}
</script>
